export const loadingConfig = {
  loadingUsers: {
    titleNormalText: 'Retrieving your',
    titleBoldText: 'Payment History list...',
    description: 'This might take few seconds, Please wait !',
  },
  usersEmpty: {
    titleNormalText: 'Payment History',
    titleBoldText: 'Not found !',
    description: '',
  },
  deleteDraft: {
    titleNormalText: 'Deleting Draft',
    description: 'This might take few seconds, Please wait !',
  },
  downloadReport: {
    titleNormalText: 'Request in progress',
    description: 'This might take few seconds, Please wait !',
  },
};
